import { TableRow, Typography } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { WorkHoursMonthlySummaryDTO } from '../../../store/types/utils/WorklogTypes'
import {
  stickyStyles,
  StyledEmployeeMonthlyHoursFooter,
  StyledEmployeeMonthlyHoursFooterCell,
} from '../../../styles/EmployeeMonthlyHoursTableStyles'

type Props = {
  workHoursMonthlySummary: WorkHoursMonthlySummaryDTO | undefined
}

const EmployeeMonthlyHoursFooter = ({ workHoursMonthlySummary }: Props) => {
  const { t } = useTranslation()

  const totals = useMemo(() => {
    return (
      workHoursMonthlySummary?.employees.map(employeeData => ({
        id: employeeData.employee.id,
        total: employeeData.days.reduce((acc, d) => acc + (d.totalHours ?? 0), 0),
      })) ?? []
    )
  }, [workHoursMonthlySummary])

  return (
    <StyledEmployeeMonthlyHoursFooter>
      <TableRow sx={{ ...stickyStyles, bottom: 0 }}>
        <StyledEmployeeMonthlyHoursFooterCell sx={{ ...stickyStyles, left: 0 }}>
          <Typography variant="body2">{t('sum')}</Typography>
        </StyledEmployeeMonthlyHoursFooterCell>
        {totals.map(employee => (
          <StyledEmployeeMonthlyHoursFooterCell key={employee.id} align="center">
            <Typography variant="body2">{employee.total}</Typography>
          </StyledEmployeeMonthlyHoursFooterCell>
        ))}
      </TableRow>
    </StyledEmployeeMonthlyHoursFooter>
  )
}

export default EmployeeMonthlyHoursFooter
